<template>
  <div class="flex-container">
    <b-card class="container-card" header-tag="header" bg-variant="light">
      <h5 slot="header" class="mb-0">Szűrők</h5>
      <div class="date-container">
        <b-form-group
          class="date-group"
          id="date-group-start"
          label-cols-sm="4"
          label="Mettől:"
          label-align-sm="left"
          label-for="datepicker-start"
        >
          <DatePicker
            id="datepicker-start"
            v-model="dateStart"
            placeholder="Nincs megadva"
            :config="options"
          ></DatePicker>
        </b-form-group>
        <b-form-group
          class="date-group"
          id="date-group-end"
          label-cols-sm="4"
          label="Meddig:"
          label-align-sm="left"
          label-for="datepicker-end"
        >
          <DatePicker
            id="datepicker-end"
            v-model="dateEnd"
            placeholder="Nincs megadva"
            :config="options"
          ></DatePicker>
        </b-form-group>
      </div>
      <b-form-group label-cols-sm="3" label="BNO:" label-align-sm="left" label-for="nested-bno">
        <MultiSelect
          id="nested-bno"
          :selected-options="bno"
          placeholder="Nincs megadva"
          :options="bnoOptions"
          @select="(items) => bno = items"
         >
        </MultiSelect>
      </b-form-group>
      <b-form-group 
        label-cols-sm="3"
        label="Nem:"
        label-align-sm="left"
        label-for="nested-sex"
        >
        <b-select
          id="nested-sex"
          v-model="sex"
          :options="sexOptions"
        >
        </b-select>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Megye:"
        label-align-sm="left"
        label-for="nested-county"
        >
        <MultiSelect
          id="nested-county"
          :selected-options="county"
          placeholder="Nincs megadva"
          :options="countyOptions"
          @select="(items) => county = items"
         >
         </MultiSelect>
      </b-form-group>

      <b-form-group
        label-cols-sm="3"
        label="Korcsoport:"
        label-align-sm="left"
        label-for="nested-age-group"
      >
        <MultiSelect
          id="nested-age-group"
          :selected-options="ageGroup"
          placeholder="Nincs megadva"
          :options="ageGroupOptions"
          @select="(items, lastSelectedItem) => ageGroup = items"
         >
         </MultiSelect>
      </b-form-group>
    </b-card>
    <b-input-group prepend="Találatok száma" class="request-group">
      <b-form-input class="request-input bg-light" :value="matches" disabled></b-form-input>
      <b-input-group-append>
        <b-button class="request-button" @click="requestData()" variant="info">Lekérdezés</b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import DatePicker from 'vue-bootstrap-datetimepicker'
import { MultiSelect } from 'vue-search-select'
import { statistics, getListValues } from "@/services/backendService"
import { datePickerConfig } from '@/services/datePickerConfig.js'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-search-select/dist/VueSearchSelect.css'

import _ from 'lodash'

export default {
  name: "Statistics",
  components: {
    DatePicker,
    MultiSelect
  },
  methods: {
    async requestData() {
      try {
        const response = await statistics(
          this.bno,
          this.sex,
          this.county,
          this.ageGroup,
          this.dateStart,
          this.dateEnd
        )
        this.matches = response.data.eredmeny.toString()
      } catch (err) {
      }
    },
    getList(endpoint) {
      getListValues(endpoint).then(listValuesData => {
        let retArray = []
        let listValues = listValuesData.data.map(item => {
          let prefix = this.lodash.get(item, 'kategoria', this.lodash.get(item, 'kod', ''))

          if (prefix.length > 0) {
            prefix = '[' + prefix + '] '
          }

          return {
            value: item.kod,
            text:  prefix + item.elnevezes
          }
        })
        this.bnoOptions = [...retArray, ...listValues]
      })
    }
  },
  data() {
    return {
      lodash: _,
      matches: null,
      dateStart: null,
      dateEnd: null,
      options: datePickerConfig,
      bno: [],
      bnoOptions: [],
      sex: null,
      sexOptions: [
        { value: null, text: "Nincs megadva"},
        { value: 1, text: "Nem ismert" },
        { value: 3, text: "nő" },
        { value: 2, text: "férfi" }
      ],
      county: [],
      countyOptions: [
        { value: "1", text: "Nem ismert" },
        { value: "2", text: "Bács-Kiskun" },
        { value: "3", text: "Baranya" },
        { value: "4", text: "Békés" },
        { value: "5", text: "Borsod-Abaúj-Zemplén" },
        { value: "6", text: "Csongrád" },
        { value: "7", text: "Fejér" },
        { value: "8", text: "Győr-Moson-Sopron" },
        { value: "9", text: "Hajdú-Bihar" },
        { value: "10", text: "Heves" },
        { value: "11", text: "Jász-Nagykun-Szolnok" },
        { value: "12", text: "Komárom-Esztergom" },
        { value: "13", text: "Nógrád" },
        { value: "14", text: "Pest" },
        { value: "15", text: "Somogy" },
        { value: "16", text: "Szabolcs-Szatmár-Bereg" },
        { value: "17", text: "Tolna" },
        { value: "18", text: "Vas" },
        { value: "19", text: "Veszprém" },
        { value: "20", text: "Zala" },
        { value: "21", text: "Budapest (főváros)" }
      ],
      ageGroup: [],
      ageGroupOptions: [
        { value: "1", text: "0-4" },
        { value: "2", text: "4-9" },
        { value: "3", text: "10-14" },
        { value: "4", text: "15-19" },
        { value: "5", text: "20-24" },
        { value: "6", text: "25-29" },
        { value: "7", text: "30-34" },
        { value: "8", text: "35-39" },
        { value: "9", text: "40-44" },
        { value: "10", text: "45-49" },
        { value: "11", text: "50-54" },
        { value: "12", text: "55-59" },
        { value: "13", text: "60-64" },
        { value: "14", text: "65-69" },
        { value: "15", text: "70-74" },
        { value: "16", text: "75-79" },
        { value: "17", text: "80-84" },
        { value: "18", text: "85-89" }
      ]
    }
  },
  mounted() {
    this.getList('bno')
  }
}
</script>

<style lang="scss">
.flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container-card {
  width: 500px;
  height: auto;
}
.date-container {
  display: flex;
  flex-direction: row;
  margin: initial -5px;
}
.date-group {
  flex: 1 1 auto;
  width: 50%;
}
#date-group-start {
  margin-right: 0.625rem;
}
#date-group-end {
  margin-left: 0.625rem;
}
.request-group {
  width: 500px;
  margin-top: 15px;
  margin-bottom: 30px;
}
.request-input {
  color: black;
}
.request-button {
  font-weight: bold;
}
</style>